export default __webpack_public_path__ + "static/media/murray_esler.ced89a11.jpg";